import AvailabilityError from '~/constants/availabilityError';
import { useVehicleAvailability } from '~/context/vdp/UserVehicleContext';

export default function useIsInExclusivePreview() {
  const { error } = useVehicleAvailability();

  return error === AvailabilityError.OnSitePrivate;
}
